'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SidebarRegion;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SidebarRegionStyled = require('./styles/SidebarRegionStyled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  spread: _propTypes2.default.bool,
  scrollable: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,

  /**
   * If region is scrollable, it requires some minHeight set
   * to work properly
   */
  scrollableMinHeight: _propTypes2.default.number
};
var defaultProps = {
  spread: false,
  scrollable: false,
  bordered: false,
  scrollableMinHeight: 200
};

function SidebarRegion(props) {
  return _react2.default.createElement(_SidebarRegionStyled.SidebarRegionStyled, {
    spread: props.spread,
    bordered: props.bordered,
    scrollable: props.scrollable,
    scrollableMinHeight: props.scrollableMinHeight
  }, props.children);
}

SidebarRegion.propTypes = propTypes;
SidebarRegion.defaultProps = defaultProps;
SidebarRegion.displayName = 'SidebarRegion';